
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABvUExURQAAAP////////////////////////////////// //////j4+8zU49Pa5/Dy99TZ56+709rg65mpyIudwNvg66i1z5KjxOLn7+ns86i20PHz973H3MXN 36GvzLfC2MXO37fC16+71MzT45qpyAAAANdV/1QAAAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAAAWJL R0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IlSlicsAAACtSURBVCjP nZLrDoIwDEa7sgFWRaWAihdQ3v8d3UAm6qoJ51fXk3ZZ9gFYFEb0hjYxDCQpBcCkd5qCaGdTEkCA mEQUGFkiTG9crtbZ5BjBWG22O8qZcyrKYux5WfH+cLTUBVdfkvk0FGfmgOTSceGw9ITktbG0guyf kc1cexOlXXsX5c+1M2X3cp2XY7TqxlM/WxpQ/mwDSpY2nuIo/osmJMHZIdSW2HxMR7hw/QfQBiO1 I2B5rgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQwMjozMjoxMyswMDowMPAPo/YAAAAl dEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6MTMrMDA6MDCBUhtKAAAAKHRFWHRkYXRl OnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM0KzAwOjAwgs/b5AAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    